import React from "react";
import formImage from "../../assets/images/png/formImage.png";

const CMYuvaFormPart2 = ({ register, errors }) => {
  return (
    <div className="row g-0 h-100">
      <div className="col-12 col-lg-7 p-4 p-md-5 d-flex flex-column justify-content-center">
        <div className="mb-4">
          <h3 className="fw-bold mb-1">Eligibility Check</h3>
          <p className="text-gray-300 small">We need to confirm a few financial details regarding loans and benefits.</p>
        </div>

        {/* Question 4: NPA Loan */}
        <div className="mb-4">
          <label className="form-label fw-semibold mb-2">
            4. Do you have any loan classified as NPA (do you have any history of loan default)?
          </label>
          <div className="d-flex gap-4 mt-1">
            <div className="custom-radio-box">
              <input
                className="form-check-input"
                type="radio"
                value="yes"
                id="npaYes"
                {...register("activeNpaLoan", { required: "Please select an option" })}
              />
              {/* REMOVED 'stretched-link' */}
              <label className="form-check-label cursor-pointer" htmlFor="npaYes">Yes</label>
            </div>
            <div className="custom-radio-box">
              <input
                className="form-check-input"
                type="radio"
                value="no"
                id="npaNo"
                {...register("activeNpaLoan")}
              />
              {/* REMOVED 'stretched-link' */}
              <label className="form-check-label cursor-pointer" htmlFor="npaNo">No</label>
            </div>
          </div>
          {errors.activeNpaLoan && <div className="text-danger small mt-2">{errors.activeNpaLoan.message}</div>}
        </div>

        {/* Question 5: Previous Benefits */}
        <div className="mb-3">
          <label className="form-label fw-semibold mb-2">
            5. Have you taken benefits from schemes like PM Vishwakarma, Mudra Yojana, etc.?
          </label>
          <div className="d-flex gap-4 mt-1">
            <div className="custom-radio-box">
              <input
                className="form-check-input"
                type="radio"
                value="yes"
                id="benefitYes"
                {...register("takenFinancialBenefits", { required: "Please select an option" })}
              />
              {/* REMOVED 'stretched-link' */}
              <label className="form-check-label cursor-pointer" htmlFor="benefitYes">Yes</label>
            </div>
            <div className="custom-radio-box">
              <input
                className="form-check-input"
                type="radio"
                value="no"
                id="benefitNo"
                {...register("takenFinancialBenefits")}
              />
              {/* REMOVED 'stretched-link' */}
              <label className="form-check-label cursor-pointer" htmlFor="benefitNo">No</label>
            </div>
          </div>
          {errors.takenFinancialBenefits && <div className="text-danger small mt-2">{errors.takenFinancialBenefits.message}</div>}
        </div>
      </div>

      {/* Image Side */}
      <div className="col-lg-5 d-none d-lg-block bg-gradient-to-b from-[#0a0a0a] via-[#0f172a] to-[#0a0a0a] position-relative">
        <img src={formImage} alt="Illustration" className="w-100 h-100 object-fit-cover" />
      </div>
    </div>
  );
};

export default CMYuvaFormPart2;
